import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import http from '../utils/http';
import { DocumentReference } from './DocumentsSlice';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { TaxonomyTypeEnum } from './TaxonomyVersionSlice';


export interface SystemReportParameter {
    afrYear: number;
    reportFormat: string;
    reportName: string;
}

export const ReportGroupMapping : any = {
    ALL: 'All Groups',
    CODES: 'Account Codes',
    COURT_REPORTING: 'Court Reporting',
    DETAILS: 'Account Details',
    GENERALADMIN: 'General Administration',
    REG: 'Regulation',
    SD: 'Special District',
}
export interface ReportState {
    reportYears: Array<number>,
    reportGroup: string,
    status: 'idle' | 'loading' | 'failed';
}


const initialState: ReportState = {
    reportYears: [],
    reportGroup: "ALL",
    status: 'idle'
}
export const getSystemReport = createAsyncThunk(
    "Report/GetSystemReport",
    async(reportParameter: SystemReportParameter): Promise<DocumentReference | null> => {
        try {
            const result = await http<SystemReportParameter, DocumentReference>({
                path: `/document/systemReport`,
                method: 'post',
                body:reportParameter
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const getReportYears = createAsyncThunk(
    "Report/GetReportYears",
    async ( taxType: TaxonomyTypeEnum | null ): Promise<Array<number> | null> => {
        try {
            if (!taxType) {
                taxType = TaxonomyTypeEnum.AFR;
            }
            const result = await http<null, Array<number>>({
                path: `/document/${taxType}/reportYears`,
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const getMax939Year = createAsyncThunk(
    "Report/GetMax939Year", async (): Promise<number | null> => {
        try {

            const result = await http<null, number>({
                path: `/document/getMax939Year`,
            });

            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const refreshLongRunningReport = createAsyncThunk(
    "Report/RefreshLongRunningReport",
    async (reportParameter: SystemReportParameter): Promise<string | null> => {
        try {
            const result = await http<SystemReportParameter, string>({
                path: `/document/refreshLongRunningReport`,
                method: 'post',
                body: reportParameter
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const reportSlice = createSlice({
    name: 'Report',
    initialState,
    reducers: {
        clearState: (state: any, action: any) => {
            state = initialState;
        },
        setReportGroup: {
            reducer(state: any, action: any) {
                state.reportGroup = action.payload;
            },
            prepare(payload: string) {
                return {
                    payload
                }
            }
        }        
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getSystemReport.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getSystemReport.fulfilled, (state: any, action: any) => {
                if (action.payload) {

                }
                state.status = "idle";
            })
            .addCase(getReportYears.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getReportYears.fulfilled, (state: any, action: any) => {
                if (action.payload) {
                    state.reportYears = action.payload;
                }
                state.status = "idle";
            })
            .addCase(getMax939Year.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getMax939Year.fulfilled, (state: any, action: any) => {               
                state.status = "idle";
            })
            .addCase(refreshLongRunningReport.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(refreshLongRunningReport.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            })
    }
});

export const { clearState, setReportGroup } = reportSlice.actions;

export const selectAvailableReportYears = (state: RootState) => state.report.reportYears;

export const selectReportStatus = createDraftSafeSelector(
    (state: RootState) => state,
    (state: any) => state.report.status
);

export const selectReportGroup = createDraftSafeSelector(
    (state: RootState) => state,
    (state: any) => state.report.reportGroup
);

export default reportSlice.reducer;


